// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slider-guide-container[data-v-a4419a62] {\n  width: 100%;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0,0,0,0.24);\n  color: #fff;\n}\n.slider-guide-container .slider-icon[data-v-a4419a62] {\n  width: 24px;\n  height: 24px;\n  margin-right: 4px;\n}\n.slider-guide-container .slider-tip[data-v-a4419a62] {\n  font-size: 15px;\n  font-weight: 500;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
